import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Navbar from "../../../Member/Navbar/Navbar";
import "./profile.css";
import ServiceAdmin from "../Services/ServiceAdmin";
//
// import EditProfile from "./EditProfile";
import EditeCabiner from "./EditeCabiner";
import EditeService from "./EditeService";
//
import checkAuth from "../../../Login/Services/check-auth";

function Profile() {
  const currnetUser = JSON.parse(sessionStorage.getItem("user"));

  const healthPro =
    JSON.parse(sessionStorage.getItem("healthId")) &&
    JSON.parse(sessionStorage.getItem("healthId")).id;

  const [profileInfos, setProfileInfos] = useState();
  const [details, setDetails] = useState();

  //const [detailsInfo, setDetailsInfo] = useState([]);
  //
  //const items = profileInfos && JSON.parse(profileInfos.laboratory.details);

  useEffect(() => {
    getprofileInfo();
  }, []);

  //
  const getprofileInfo = () => {
    ServiceAdmin.getprofile(healthPro).then((res) => {
      console.log("api get ", res.data.laboratory);
      if (res.data) {
        setProfileInfos(res.data);
        setDetails(JSON.parse(res.data.details));
        // setDetailsInfo(JSON.parse(res.data.laboratory));
        sessionStorage.setItem(
          "dataCabinet",
          JSON.stringify(res.data.laboratory ? res.data.laboratory : {})
        );
      }
    });
  };

  // const convertString = () => {
  //   details.get("presentation");
  // };

  // console.log("details==>", convertString());
  // console.log("convertString==>", convertString());
  // profile
  const [show, setShow] = useState(false);
  const HandleShow = () => setShow(true);
  const Toggle = () => {
    setShow(false);
  };

  //
  const [show2, setShow2] = useState(false);
  const HandleShow2 = () => setShow2(true);
  const Toggle2 = () => {
    setShow2(false);
  };

  const [showService, setShowService] = useState(false);
  const HandleShowService = () => setShowService(true);
  const ToggleService = () => {
    setShowService(false);
  };
  const dataProfile = [
    {
      presentation: "presentation",
      diplomes: {
        date: "2",
        discription: "3",
      },
      experiences: "experiences",
      Horaires: {
        lundi: {
          matin: { time1: "7", time2: "8" },
          soir: { time1: "9", time2: "10" },
        },
        mardi: {
          matin: { time1: "11", time2: "12" },
          soir: { time1: "13", time2: "14" },
        },
        mecredi: {
          matin: { time1: "15", time2: "16" },
          soir: { time1: "17", time2: "18" },
        },
        jeudi: {
          matin: { time1: "19", time2: "20" },
          soir: { time1: "21", time2: "22" },
        },
        vendredi: {
          matin: { time1: "23", time2: "24" },
          soir: { time1: "25", time2: "26" },
        },
        Samedi: {
          matin: { time1: "27", time2: "28" },
          soir: { time1: "29", time2: "30" },
        },
      },
      secretariat: "31",
      sociaux: {
        facebook: "",
        linkedin: "",
        instagram: "",
      },
    },
  ];

  // const items = details;
  // console.log(items);
  // const dataProfile = detailsInfo[0];
  // console.log("dataprofile", dataProfile);
  //console.log("labo infos $$$", items);
  //const profile = detailsInfo && JSON.parse(detailsInfo.details);
  return (
    <>
      <Navbar />

      <div
        className="container bootstrap snippets bootdeys"
        style={{ marginTop: "20px" }}
      >
        <div className="row" id="user-profile">
          <div className="col-lg-3 col-md-4 col-sm-4">
            <div className="main-box clearfix">
              <h2>
                {profileInfos &&
                  `${profileInfos.firstName} ${profileInfos.lastName} `}
              </h2>
              {/* <div className="profile-status">
                <i className="fa fa-check-circle"></i> Online
              </div> */}
              <img
                src="https://bootdey.com/img/Content/avatar/avatar1.png"
                alt=""
                width="100%"
                className="profile-img img-responsive center-block"
              />
              <div className="profile-stars">
                <div className="profile-user-details clearfix">
                  <div className="profile-user-details-label">
                    <b>Address:</b>
                  </div>
                  <div className="profile-user-details-value">
                    {profileInfos && profileInfos.laboratory
                      ? profileInfos.laboratory.address
                      : "-"}
                    <br />
                    {profileInfos && profileInfos.city
                      ? profileInfos.city.name
                      : "-"}
                  </div>
                </div>
                <div className="profile-user-details clearfix">
                  <div className="profile-user-details-label">
                    <b>Email:</b>
                  </div>
                  <div className="profile-user-details-value">
                    {profileInfos && profileInfos.email}
                  </div>
                </div>
                <div className="profile-user-details clearfix">
                  <div className="profile-user-details-label">
                    <b>Phone:</b>
                  </div>
                  <div className="profile-user-details-value">
                    {profileInfos && profileInfos.tel}
                  </div>
                </div>
              </div>
              {details && (
                <div className="profile-details">
                  <ul className="fa-ul">
                    <li>
                      <i className="fa-li fa fa-linkedin-square"></i>
                      <a
                        href={details.sociaux && details.sociaux.linkedin}
                        target="_blank"
                      >
                        Linkdin
                      </a>
                    </li>
                    <li>
                      <i className="fa-li fa fa-facebook-square"></i>
                      <a
                        href={details.sociaux && details.sociaux.facebook}
                        target="_blank"
                      >
                        Facebook{" "}
                      </a>
                    </li>
                    <li>
                      <i className="fa-li fa fa-instagram"></i>
                      <a
                        href={details.sociaux && details.sociaux.instagram}
                        target="_blank"
                      >
                        Instagram
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {checkAuth && currnetUser && currnetUser.role === "ADMIN" ? (
                ""
              ) : checkAuth && currnetUser && currnetUser.role === "USER" ? (
                ""
              ) : profileInfos && profileInfos.role === "USER" ? (
                ""
              ) : (
                <div className="profile-message-btn center-block text-center">
                  <Link
                    to={
                      currnetUser
                        ? profileInfos && profileInfos.speciality
                          ? "/pageanalyse"
                          : "/home"
                        : "/login"
                    }
                  >
                    <Button
                      className="m-auto "
                      variant="primary"
                      style={{ fontSize: "smaller", color: "white" }}
                      onClick={() => {
                        // sessionStorage.setItem(
                        //   "Type",
                        //   JSON.stringify({
                        //     type: "No Covid",
                        //   })
                        // );
                        profileInfos &&
                          sessionStorage.setItem(
                            "lieux",
                            JSON.stringify(
                              profileInfos.laboratory
                                ? profileInfos.laboratory
                                : {}
                            )
                          );
                      }}
                    >
                      <i
                        className="fas fa-calendar-check mr-2"
                        style={{
                          color: "white",
                          backgroundColor: "#0596de",
                        }}
                      ></i>
                      PRENDRE RENDEZ-VOUS
                    </Button>
                  </Link>
                </div>
              )}
            </div>
          </div>
          {/* {dataProfile &&
            dataProfile.map((profile) => {
              console.log("dedededed --------->", profile.experiences);
              return ( */}
          <div className="col-lg-9 col-md-8 col-sm-8">
            <div className="main-box clearfix">
              {currnetUser && currnetUser.role == "ADMIN" ? (
                <div className="profile-header">
                  <Link to="/services">
                    <Button
                      // onClick={() => {
                      //   HandleShowService();
                      // }}
                      className="btn ml-2 mb-2 btn-info edit-profile"
                    >
                      <i className="fa fa-pencil-square fa-lg"></i> Services
                    </Button>
                  </Link>
                  <Button
                    variant="success"
                    onClick={() => {
                      HandleShow2();
                    }}
                    className="btn ml-2 mb-2 edit-profile"
                  >
                    <i className="fa fa-pencil-square fa-lg"></i> Cabinet
                  </Button>
                  <Link to="/editeprofile">
                    <Button className="btn mb-2 btn-primary edit-profile">
                      <i className="fa fa-pencil-square fa-lg"></i> Profile
                    </Button>
                  </Link>
                </div>
              ) : currnetUser && currnetUser.role == "USER" ? (
                <div className="profile-header">
                  <Button
                    disabled
                    className="btn ml-2 mb-2 btn-info edit-profile"
                  >
                    <i className="fa fa-pencil-square fa-lg"></i> Services
                  </Button>
                  <Button
                    variant="success"
                    onClick={() => {
                      HandleShow2();
                    }}
                    className="btn ml-2 mb-2 edit-profile"
                  >
                    <i className="fa fa-pencil-square fa-lg"></i> Cabinet
                  </Button>
                  <Link to="/editeprofile">
                    <Button className="btn mb-2 btn-primary edit-profile">
                      <i className="fa fa-pencil-square fa-lg"></i> Profile
                    </Button>
                  </Link>
                </div>
              ) : (
                ""
              )}
              <div className="profile-header">
                {details && (
                  <>
                    <h3>
                      <span>Présentation :</span>
                    </h3>
                    <p>{details.presentation}</p>
                  </>
                )}
              </div>
              <div className="profile-header">
                <p>
                  {details &&
                    details.diplomes.map((diplome) => {
                      return (
                        <>
                          <h3>
                            <span>Diplômes :</span>
                          </h3>
                          <p>
                            <b>{diplome.date}</b>
                            {" : "} {diplome.discription}
                          </p>
                        </>
                      );
                    })}
                </p>
              </div>
              <div className="profile-header">
                {details &&
                  details.experiences.map((exp) => {
                    return (
                      <>
                        <h3>
                          <span>Expériences :</span>
                        </h3>
                        <p>
                          <b>{exp.dateD}</b> - <b>{exp.dateF}</b>{" "}
                          {exp.discription}
                        </p>
                      </>
                    );
                  })}
              </div>
            </div>
            <div className="main-box clearfix" style={{ marginTop: "10px" }}>
              <div className="profile-header">
                {details && details.horaires && (
                  <>
                    <h3>
                      <span>Horaires et contacts :</span>
                    </h3>
                    <b>Ouverture du secrétariat</b> <br />
                    <table className="w-100">
                      <tr>
                        <th>Lundi :</th>
                        <td>
                          {details.horaires.lundi.matin.time1} -
                          {details.horaires.lundi.matin.time2}
                        </td>
                        <td>
                          {details.horaires.lundi.soir.time1} -
                          {details.horaires.lundi.soir.time2}
                        </td>
                        <br />
                      </tr>
                      <tr>
                        <th>Mardi :</th>
                        <td>
                          {details.horaires.mardi.matin.time1} -
                          {details.horaires.mardi.matin.time2}
                        </td>
                        <td>
                          {details.horaires.mardi.soir.time1} -
                          {details.horaires.mardi.soir.time2}
                        </td>
                        <br />
                      </tr>
                      <tr>
                        <th>Mercredi :</th>
                        <td>
                          {details.horaires.mecredi.matin.time1} -
                          {details.horaires.mecredi.matin.time2}
                        </td>
                        <td>
                          {details.horaires.mecredi.soir.time1} -
                          {details.horaires.mecredi.soir.time2}
                        </td>
                        <br />
                      </tr>
                      <tr>
                        <th>jeudi :</th>
                        <td>
                          {details.horaires.jeudi.matin.time1} -
                          {details.horaires.jeudi.matin.time2}
                        </td>
                        <td>
                          {details.horaires.jeudi.soir.time1} -
                          {details.horaires.jeudi.soir.time2}
                        </td>
                        <br />
                      </tr>
                      <tr>
                        <th>Vendredi :</th>
                        <td>
                          {details.horaires.vendredi.matin.time1} -
                          {details.horaires.vendredi.matin.time2}
                        </td>
                        <td>
                          {details.horaires.vendredi.soir.time1} -
                          {details.horaires.vendredi.soir.time2}
                        </td>
                        <br />
                      </tr>
                      <tr>
                        <th>Samedi :</th>
                        <td>
                          {details.horaires.Samedi.matin.time1} -
                          {details.horaires.Samedi.matin.time2}
                        </td>
                        <td>
                          {details.horaires.Samedi.soir.time1} -
                          {details.horaires.Samedi.soir.time2}
                        </td>
                        <br />
                      </tr>
                    </table>
                  </>
                )}
                {details && (
                  <p>
                    <b>Contact du secrétariat</b> <br />
                    {details.secretariat}
                  </p>
                )}
              </div>
            </div>
          </div>
          {/* ); })} */}
        </div>
      </div>
      {/* <EditProfile
        show={show}
        Toggle={Toggle}
        profile={profileInfos}
        id={healthPro}
      /> */}

      <EditeCabiner
        show2={show2}
        Toggle2={Toggle2}
        cabinet={profileInfos ? profileInfos : {}}
      />
      <EditeService
        showService={showService}
        ToggleService={ToggleService}
        cabinet={profileInfos ? profileInfos : {}}
      />
    </>
  );
}

export default Profile;
